<template>
  <div class="time-line">
    <div class="title">
      <div class="team">
        <img :src="imageView(homeTeam.badge)" alt="">
        <div class="name">{{ homeTeam.name }}</div>
      </div>
      <div class="team">
        <img :src="imageView(awayTeam.badge)" alt="">
        <div class="name">{{ awayTeam.name }}</div>
      </div>
    </div>
    <div class="list">
      <div class="base" v-for="(item, index) in list" :key="item.id">
        <div class="center">
          <div class="point">
            <span style="color: #FFFFFF">{{ item.time }}</span>
          </div>
          <div class="line" v-if="list.length - 1 > index"></div>
          <div @click="editEvent(item)" :class="item.teamId === homeTeam.id ? 'left' : 'right'" class="box">
            <div class="info" v-if="item.type === 'goal' || item.type === 'penalty'">
              <div class="row" :style="item.teamId === homeTeam.id ? { 'justify-content': 'right' } : { 'flex-flow': 'row-reverse', 'justify-content': 'left' }">
                <span>{{ item.number ? `(${item.number})`:''}}{{ item.trueName }}</span>
                <img src="../../../assets/football/goal.png" :style="item.teamId === homeTeam.id ? { 'margin-left': '8px' } : { 'margin-right': '8px' }" alt="">
              </div>
              <div class="row" v-if="item.otherPlayerId" :style="item.teamId === homeTeam.id ? { 'justify-content': 'right' } : { 'flex-flow': 'row-reverse', 'justify-content': 'left' }">
                <span>{{ item.number ? `(${item.number})`:''}}{{ item.otherName }}</span>
                <img src="../../../assets/football/assist.png" :style="item.teamId === homeTeam.id ? { 'margin-left': '8px' } : { 'margin-right': '8px' }" alt="">
              </div>
            </div>
            <div class="info" v-else-if="item.type === 'ownGoal'">
              <div class="row" :style="item.teamId === homeTeam.id ? { 'justify-content': 'right' } : { 'flex-flow': 'row-reverse', 'justify-content': 'left' }">
                <span>{{ item.number ? `(${item.number})`:''}}{{ item.trueName }}</span>
                <img src="../../../assets/football/goal.png" :style="item.teamId === homeTeam.id ? { 'margin-left': '8px' } : { 'margin-right': '8px' }" alt="">
              </div>
            </div>
            <div class="info" v-else-if="item.type === 'changes'">
              <div class="row" :style="item.teamId === homeTeam.id ? { 'justify-content': 'right' } : { 'flex-flow': 'row-reverse', 'justify-content': 'left' }">
                <span>{{ item.number ? `(${item.number})`:''}}{{ item.trueName }}</span>
                <img src="../../../assets/football/up.png" :style="item.teamId === homeTeam.id ? { 'margin-left': '8px' } : { 'margin-right': '8px' }" alt="">
              </div>
              <div class="row" :style="item.teamId === homeTeam.id ? { 'justify-content': 'right' } : { 'flex-flow': 'row-reverse', 'justify-content': 'left' }">
                <span>{{ item.number ? `(${item.number})`:''}}{{ item.otherName }}</span>
                <img src="../../../assets/football/down.png" :style="item.teamId === homeTeam.id ? { 'margin-left': '8px' } : { 'margin-right': '8px' }" alt="">
              </div>
            </div>
            <div class="info" v-else-if="item.type === 'yellow'">
              <div class="row" :style="item.teamId === homeTeam.id ? { 'justify-content': 'right' } : { 'flex-flow': 'row-reverse', 'justify-content': 'left' }">
                <span>{{ item.number ? `(${item.number})`:''}}{{ item.trueName }}</span>
                <img src="../../../assets/football/yellow.png" :style="item.teamId === homeTeam.id ? { 'margin-left': '8px' } : { 'margin-right': '8px' }" alt="">
              </div>
            </div>
            <div class="info" v-else-if="item.type === 'red'">
              <div class="row" :style="item.teamId === homeTeam.id ? { 'justify-content': 'right' } : { 'flex-flow': 'row-reverse', 'justify-content': 'left' }">
                <span>{{ item.number ? `(${item.number})`:''}}{{ item.trueName }}</span>
                <img src="../../../assets/football/red.png" :style="item.teamId === homeTeam.id ? { 'margin-left': '8px' } : { 'margin-right': '8px' }" alt="">
              </div>
            </div>
            <div class="info" v-else-if="item.type === 'assist'">
              <div class="row" :style="item.teamId === homeTeam.id ? { 'justify-content': 'right' } : { 'flex-flow': 'row-reverse', 'justify-content': 'left' }">
                <span>{{ item.number ? `(${item.number})`:''}}{{ item.otherName }}</span>
                <img src="../../../assets/football/assist.png" :style="item.teamId === homeTeam.id ? { 'margin-left': '8px' } : { 'margin-right': '8px' }" alt="">
              </div>
            </div>
            <div class="info" v-else-if="item.type === 'leaveBench'">
              <div class="row" :style="item.teamId === homeTeam.id ? { 'justify-content': 'right' } : { 'flex-flow': 'row-reverse', 'justify-content': 'left' }">
                <span>{{ item.number ? `(${item.number})`:''}}{{ item.trueName }}</span>
                <img src="../../../assets/football/exit.png" :style="item.teamId === homeTeam.id ? { 'margin-left': '8px' } : { 'margin-right': '8px' }" alt="">
              </div>
            </div>
            <div class="delete" @click.stop.prevent="cancelEvent(item.id)">删除</div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 40px;"></div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Toast, Dialog } from 'vant'
Vue.use(Toast).use(Dialog)
import { adminDeleteBMGameEvent, getBMGameDetail, getBMGameEventList } from "@/api/match";
import { QNImageUtil } from "@/utils";

export default {
  data() {
    return {
      gameId: '',
      homeTeam: {},
      awayTeam: {},
      list: [],
      matchId: ''
    }
  },
  mounted() {
    this.gameId = this.$route.query.gameId
    this.getBMGameDetail()
    this.getBMGameEventList()
  },
  methods: {
    cancelEvent(id) {
      Dialog.confirm({
        title: '提示',
        message: '是否确认删除该事件',
      }).then(() => {
        const params = {
          eventId: id
        }
        adminDeleteBMGameEvent(params).then(res => {
          if (res) {
            Toast.success('删除成功')
            this.getBMGameEventList()
          }
        })
      })
    },
    getBMGameEventList() {
      const params = {
        gameId: this.gameId
      }
      getBMGameEventList(params).then(res => {
        if (res) {
          const { data } = res
          this.list = data.list.filter(item => item.type !== 'penaltyShootoutShot') || []
        }
      })
    },
    getBMGameDetail() {
      getBMGameDetail({ gameId: this.gameId }).then(res => {
        if (res) {
          const { data } = res
          const game = data.game || {}
          this.matchId = game.match.id
          this.homeTeam = game.homeTeam
          this.awayTeam = game.awayTeam
        }
      })
    },
    imageView(img, w, h) {
      if (!img) return ''
      return QNImageUtil.imageView(img, w, h)
    },
    editEvent(item) {
      /**
       * TODO
       */
      localStorage.setItem('bmb-event', JSON.stringify(item))
      this.$router.push(`/match-manage/football-statistics?matchId=${this.matchId}&id=${this.gameId}&active=1&eventId=${item.id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.time-line {
  min-height: 100vh;
  background: #F6F6F8;
  .title {
    display: flex;
    justify-content: space-around;
    padding: 12px 0;
    background-color: #FFFFFF;
    .team {
      img{
        width: 90px;
        height: 90px;
        border-radius: 4px;
        border: 1px solid #E5E5E5;
      }
      .name {
        font-size: 14px;
        font-weight: 500;
        text-align: center;
      }
    }
  }
  .list {
    padding: 20px 12px;
    .base {
      display: flex;
      justify-content: center;
      align-items: center;
      .center {
        width: 4%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: column;
        position: relative;
        .line {
          width: 2px;
          height: 45px;
          background-color: #67C23A;
        }
        .point {
          margin: 2px 0;
          width: 26px;
          height: 26px;
          border-radius: 50%;
          background-color: #67C23A;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .box {
          border-radius: 4px;
          position: absolute;
          background-color: #FFFFFF;
          width: 38vw;
          top: -5px;
        }
        .left {
          left: -41vw;
          display: flex;
          flex-flow: row-reverse;
          align-items: center;
          justify-content: space-between;
          padding: 0 8px;
          box-sizing: border-box;
        }
        .right {
          display: flex;
          right: -41vw;
          align-items: center;
          justify-content: space-between;
          padding: 0 8px;
          box-sizing: border-box;
        }
        .info {
          background-color: #FFFFFF;
          padding: 8px 0;
          border-radius: 4px;
          .row {
            display: flex;
            align-items: center;
            span {
              font-size: 14px;
              color: #333333;
            }
            img {
              width: 18px;
              height: 18px;
            }
          }
        }
        .delete {
          font-size: 13px;
          color: #F56C6C;
        }
      }
    }
  }
}
</style>
